<template>
  <div class="real-time-monitor">
    <!-- Tab内容区域 -->
    <div class="monitor-layout">
      <!-- 左侧：运行示意图 -->


      <!-- 右侧：储能系统状态和设备卡片 -->
      <!-- <SystemDiagram :hasPvModule="hasPvModule" :hasChargerModule="hasChargerModule"
        :diagram-data="diagramRealTimeData" /> -->

      <div class="left-panel">
        <SocPowerCurve :power-tracking-data="powerTrackingData" :loading-elink="loadingElink" />
        <StrategyChart class="mt-4" />
      </div>

      <div class="right-panel">
        <div class="right-panel-content">
          <DeviceCards :hasPvData="hasPvModule" :hasChargerData="hasChargerModule"
            :diagram-data="diagramRealTimeData" />
          <MiniDiagram :has-pv-module="hasPvModule" :has-charger-module="hasChargerModule"
            :diagram-data="diagramRealTimeData" />
          <WeatherCard />
        </div>
        <!-- <EnergyStorageStatus :elink-data="elinkData" :station-id="stationId" /> -->
        <!-- 底部：SOC-功率跟踪分析曲线 -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { ws_req } from '@/ws/wss-request'
// import useUserStore from '@/store/modules/user'

/* components */
// import SystemDiagram from '../components/real-time-monitor/SystemDiagram.vue'
// import EnergyStorageStatus from '../components/real-time-monitor/EnergyStorageStatus.vue'
import DeviceCards from '../components/real-time-monitor/DeviceCards.vue'
import SocPowerCurve from '../components/real-time-monitor/SocPowerCurve.vue'
import StrategyChart from '../components/real-time-monitor/StrategyChart.vue'
import MiniDiagram from '../components/real-time-monitor/MiniDiagram.vue'
import WeatherCard from '../components/real-time-monitor/WeatherCard/index.vue'

import { useRealData } from '@/hooks/useRealData'
// import StationTopo from '../components/topology/index.vue'

// 接收父组件传递的基础数据
const props = defineProps({
  baseData: {
    type: Object,
    default: () => ({})
  },
  elinkData: {
    type: Array,
    default: () => []
  },
  loadingElink: {
    type: Boolean,
    default: false
  },
  powerTrackingData: {
    type: Array,
    default: () => []
  }
})

// 获取 stationId
const route = useRoute()
const stationId = computed(() => route.query.stationId || route.params.stationId || '1')

// 运行示意图实时数据
// const diagramRealTimeData = ref({})
// let diagramWsTimer = null

// 计算是否有光伏和充电桩
const hasPvModule = computed(() => {
  return props.baseData?.pv_access === true || props.baseData?.pv_access === 1
})

const hasChargerModule = computed(() => {
  return (props.baseData?.charging_pile_access || 0) > 0
})

const { realData: diagramRealTimeData, updateOnce } = useRealData({
  interval: 5000,
  updateFunction: () => {
    return ws_req.request('ws_running_riagram', {
      stationId: stationId.value
    })
  },
  onUpdate: (data) => {
    console.log('data--->', data);
  }
})


watch(stationId, () => {
  updateOnce()
})

</script>

<style scoped lang="scss">
.real-time-monitor {
  min-width: 0;
  max-width: 100%;
}

.monitor-layout {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
}

.left-panel {
  flex: 1 1 0;
  min-width: 0;
}

.right-panel {
  flex: 0 1 560px;
  width: 560px;
  max-width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.right-panel-content {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

@media (max-width: 1366px) {
  .right-panel {
    flex-basis: 460px;
    width: 460px;
  }
}

@media (max-width: 1024px) {
  .monitor-layout {
    flex-direction: column;
  }

  .right-panel {
    width: 100%;
    flex-basis: auto;
  }

  .right-panel-content {
    position: static;
  }
}
</style>
